import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { getLeaveRequests } from "src/redux/api/_hr_attendance.api";
import { LeaveRequest } from "src/redux/types/_attendance.type";

export interface Filters {
  page: number;
  pagesize: number;
  name?: string;
};

export const leaveKeys = {
  all: ["hr-leaves"] as const,
  list: (filter: Filters) => [...leaveKeys.all, "list", filter] as const,
};

export const useLeaves = (filter: Filters) => {
  return useQuery<LeaveRequest[]>({
    queryKey: leaveKeys.list(filter),
    queryFn: () => getLeaveRequests(filter),
    placeholderData: keepPreviousData,
    staleTime: 1000 * 60 * 60,
    gcTime: 1000 * 60 * 60,
  });
};
